import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { StyledLink } from '../components/Link';
import Logo from '../logo.svg';
import menuIcon from '../images/menuIcon.svg';
import { Line } from '../components/visuals';
import { useContact } from '../contexts/ContactContext';

const HeadersWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9999;
    width: 100%;
    transition: background-color 0.3s ease;

    &.active {
	@media screen and (min-width: 1080px){}

	background-color: #04061C;

        #mobileHeader {
			&>header{
			padding-top: 20px;
			}
            a {
                //color: black;
            }
        }
        
        #desktopHeader {
		padding-top: 20px;
            a {
                //color: black;
            }
            
        }
    }

	&>#desktopHeader {
		transition: ease-in-out 0.3s;
		display: none;
	}

	@media screen and (min-width: 1080px) {
		&>#desktopHeader {
			display: flex;
			justify-content: center;
			align-items: center; 
			padding-block: 50px 20px;
 			gap: 5rem;

			&>ul{
			display: flex; 
			justify-content: center;
			align-items: center; 
			gap: 20px;

			li{
				list-style: none;
					
					&>a{
						text-wrap: nowrap;
						color: white;
						transition: color 0.3s ease;
					}

					&>button{
						text-wrap: nowrap;
						border: 1px solid white;
						padding: 15px 20px 12px;
						background: transparent;
						color: white;
						cursor: pointer;
						transition: all 0.3s ease;
						border-radius: 30px;
						&:hover{
							background: white;
							color: black;
						}
					}
				}
			}


			&>img {
				// position: absolute;
				// top: 35px;
				// left: 15%;

				@media screen and (min-width: 1500px) {
					// left: 20%;
				}
			}
		}

		&>#mobileHeader {
			transition: ease-in-out 0.3s;
			display: none;
		}
	}
`;

const StyledHeader = styled.header`
	transition: ease-in-out 0.3s;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 50px 35px 20px;
	
	a {
		color: white;
		transition: color 0.3s ease;
	}
`;

const MinusIcon = styled.div`
	width: 30px;
	height: 3px;
	background: white;
	transition: background-color 0.3s ease;
`;

const Menu = styled.ul`
	position: fixed;
	background: ${props => props.theme.darkBg1};
	top: 0;
	bottom: 0;
	right: 0;
	width: 50%;
	transform: translateX(${props => props.$isopen ? '0' : '100%' });
	transition: transform 0.3s ease-in-out;
	z-index: 10;
	padding: 20px;

	display: flex;
	flex-direction: column;
	align-items: end;
	
	a {
		color: white;
		transition: color 0.3s ease;
	}

	@media screen and (min-width: 800px) {
        width: 30%;
    }
`;

const MenuItem = styled.li`
	padding: 10px 0;
	width: 100%;
`;

const DesktopMenu = styled.ul`
	// display: flex;
	// width: 600px;
	// justify-content: space-between;
	// text-align: center;

`;

const AnimatedLink = styled(StyledLink)`
	position: relative;
	display: inline-block;
	
	&::after {
		content: '';
		position: absolute;
		bottom: -4px;
		left: 0;
		width: 0;
		height: 2px;
		background: currentColor;
		transition: width 0.3s ease;
	}
	
	&:hover::after,
	&:focus::after {
		width: 100%;
	}
	
	&:hover,
	&:focus {
		outline: none;
	}
`;

export default function Header() {
	const [isMenuOpen, setMenuOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);
	const { openContact } = useContact();

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setIsScrolled(scrollPosition > 50); // Activate after scrolling 50px
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const toggleMenu = () => {
		setMenuOpen(!isMenuOpen);
	};

	const handleClick = () => {
		toggleMenu();
		openContact();
	};

	return (
		<HeadersWrapper className={isScrolled ? 'active' : ''}>
			<header id="mobileHeader">
				<StyledHeader>
					<img src={Logo} alt="" width="51px" height="52px" />
					<img src={menuIcon} alt="" height="24px" width="33px" onClick={toggleMenu} />
				</StyledHeader>
				<Menu $isopen={isMenuOpen}>
					<div style={{height: "25px", 
						width: "31px",
						margin: "20px 20px 30px 0",
						display: "flex",
						justifyContent: "center",
						alignItems: "center"}} onClick={toggleMenu}>
						<MinusIcon />
					</div>
				<MenuItem><AnimatedLink onClick={toggleMenu} href="#services">Services</AnimatedLink><Line /></MenuItem>
				<MenuItem><AnimatedLink onClick={toggleMenu} href="#projects">Work</AnimatedLink><Line /></MenuItem>
				<MenuItem><AnimatedLink onClick={toggleMenu} href="#pricing">Pricing</AnimatedLink><Line /></MenuItem>
				<MenuItem><AnimatedLink onClick={toggleMenu} href="#about">About</AnimatedLink><Line /></MenuItem>
				<MenuItem><StyledLink as="button" onClick={handleClick}>Get a quote</StyledLink><Line /></MenuItem>
				</Menu>
			</header>
			<header id="desktopHeader">
				<img src={Logo} alt="" width="51px" height="52px" />
				<DesktopMenu>
				<MenuItem><AnimatedLink href="#services">Services</AnimatedLink></MenuItem>
				<MenuItem><AnimatedLink href="#projects">Work</AnimatedLink></MenuItem>
				<MenuItem><AnimatedLink href="#pricing">Pricing</AnimatedLink></MenuItem>
				<MenuItem><AnimatedLink href="#about">About</AnimatedLink></MenuItem>
				<MenuItem><StyledLink as="button" onClick={() => openContact()}>Get a quote</StyledLink></MenuItem>
				</DesktopMenu>
			</header>
		</HeadersWrapper>
	);
};